import { useEffect } from 'react';

import { HilmaSocket } from '../types';

import useSocket from './useSocket';

const useLeave = (...[name, fn]: Parameters<HilmaSocket['join']>) => {
	const socket = useSocket();

	useEffect(() => {
		return () => {
			(async () => {
				if (!Array.isArray(name)) return socket.leave(name, fn);

				try {
					await Promise.all(name.map(name => socket.leave(name)));
					fn && fn();
				} catch (error) {
					fn && fn(error);
				}
			})();
		}
	}, [name]);
}

export default useLeave;